import {Component, model, output} from '@angular/core';
import {NgClass} from '@angular/common';

@Component({
  selector: 'app-adicionar-demanda-steps',
  imports: [
    NgClass
  ],
  templateUrl: './adicionar-demanda-steps.component.html',
  styleUrl: './adicionar-demanda-steps.component.css'
})
export class AdicionarDemandaStepsComponent {
  activeStep = model(0);
  handleStepClick = output<number>();
}
